/* tslint:disable:max-line-length */
import * as React from 'react'

export const ROOMTYPE = {
  shared: (
    <g>
      <g id="Laag_1" display="none">
        <g id="Laag_1_1_" display="inline">
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
        </g>
      </g>
      <g id="Laag_2" display="none">
        <g id="Laag_4_3_" display="inline">
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
        </g>
      </g>
      <g id="Laag_3">
        <g id="Laag_3_1_">
          <g>
            <path
              fill="#222222"
              d="M271.4,223.7c0-0.3,0-0.6,0-0.9v-46.2c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.6-3.1-0.2l-31.7,14.7
				l-69.5-33.7v-31.1c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.8-3.1-0.3l-67.6,28.9c-1.2,0.5-2,1.7-2,3.1v99.7c0,1.2,0.8,2.4,1.8,2.9
				l106.9,51.3c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.2-0.2,1.7-0.5c0.9-0.6,1.5-1.7,1.5-2.8v-47.6l59.8-27.7v42.4l-47.3,22.8
				c-1.7,0.8-2.3,2.8-1.5,4.4c0.8,1.7,2.8,2.3,4.4,1.5l49.1-23.7c1.2-0.6,1.8-1.7,1.8-3.1L271.4,223.7z M158.9,128.7v25.9
				l-47.6,22.2c-1.7,0.8-2.3,2.8-1.5,4.4c0.6,1.2,1.7,1.8,3.1,1.8c0.5,0,0.9-0.2,1.4-0.3l48.2-22.5l65,31.5l-26.8,12.2
				c-1.2,0.6-2,1.7-2,3.1v28.5L98,187.4v-32.7L158.9,128.7z M198.4,248.9L98,200.9v-6.1l100.4,48V248.9z M153.7,235.4l-11.8,6.3
				l-11.5-5.2l12.4-6.4L153.7,235.4z M98,208.2l23.6,11.3L98,232.1V208.2z M126.6,224.3c0.8-0.3,1.2-0.9,1.5-1.7l8.1,3.8l-14.8,7.5
				c-1.1,0.6-1.8,1.7-1.8,3.1c0,1.2,0.8,2.4,2,2.9l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.1-0.2,1.5-0.5l18.2-9.8l36.7,17.6v27.5
				L102,237.6L126.6,224.3z M98,250.1v-7.2l100.4,48v7.3L98,250.1z M205,248.7v-39.6l31.2-14.2h0.2l28.5-13.2l-0.2,39.5L205,248.7z"
            />
            <path
              fill="#222222"
              d="M132.5,190.8l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3c0.5,0,1.1-0.2,1.5-0.5l29.1-15.5c1.1-0.6,1.8-1.7,1.7-2.9
				c0-1.2-0.8-2.3-1.8-2.9l-18.1-8.7c-0.9-0.5-2-0.5-2.9,0l-30,15.5c-1.1,0.6-1.8,1.7-1.8,3.1C130.6,189.1,131.4,190.2,132.5,190.8z
				 M164,175.9l10.7,5.2l-21.9,11.6l-11.5-5.2L164,175.9z"
            />
          </g>
          <polygon fill="#222222" points="78,223.8 2,260.4 5,266.8 78,231.6 		" />
          <polygon
            fill="#222222"
            points="488.8,248.6 488.8,256.5 509,266.5 512.2,260.2 		"
          />
          <path
            fill="#222222"
            d="M369.9,189.1l-107.9-54l-61.3,29.5c2.9,1.2,5.8,2.4,8.6,3.7l52.6-25.2l99.3,49.6
			C364.1,191.5,367,190.3,369.9,189.1z"
          />
          <g>
            <path
              fill="#222222"
              d="M298.3,298.5c0,1.2,0.8,2.4,1.8,3.1l49.1,23.7c1.7,0.8,3.7,0.2,4.4-1.5s0.2-3.7-1.5-4.4l-47.3-22.8v-42.4
				l59.8,27.7v47.6c0,1.1,0.6,2.1,1.5,2.8c0.5,0.3,1.1,0.5,1.7,0.5c0.5,0,0.9-0.2,1.4-0.3L476.2,281c1.1-0.6,1.8-1.7,1.8-2.9v-99.9
				c0-1.4-0.8-2.4-2-3.1l-67.5-28.8c-1.1-0.5-2.1-0.3-3.1,0.3s-1.5,1.7-1.5,2.8v30.9L334.5,214l-31.7-14.7c-1.1-0.5-2.1-0.5-3.1,0.2
				c-0.9,0.6-1.5,1.7-1.5,2.8v46.2c0,0.3,0,0.6,0,0.9L298.3,298.5z M471.6,180.5v32.9l-100.4,48V233c0-1.2-0.8-2.4-2-3.1l-26.8-12.2
				l65-31.5l48.2,22.5c0.5,0.2,0.9,0.3,1.4,0.3c1.2,0,2.4-0.8,3.1-1.8c0.8-1.7,0-3.7-1.5-4.4l-47.7-22.2v-26L471.6,180.5z
				 M371.3,268.6l100.4-48v6.1l-100.4,48V268.6z M426.8,256.2l12.4,6.4l-11.5,5.2l-11.8-6.3L426.8,256.2z M471.6,257.8l-23.6-12.5
				l23.6-11.3V257.8z M467.8,263.3l-96.5,46.2v-27.5l36.7-17.6l18.2,9.8c0.5,0.3,1.1,0.5,1.5,0.5c0.5,0,0.9-0.2,1.4-0.3l19.1-8.7
				c1.2-0.5,1.8-1.7,2-2.9c0-1.2-0.6-2.4-1.8-3.1l-14.8-7.5l8.1-3.8c0.3,0.6,0.8,1.2,1.5,1.7L467.8,263.3z M371.3,324.2v-7.3
				l100.4-48v7.2L371.3,324.2z M305,246.9l-0.2-39.5l28.5,13.2c0,0,0,0,0.2,0l31.2,14.2v39.8L305,246.9z"
            />
            <path
              fill="#222222"
              d="M439.2,212.3c0-1.2-0.8-2.4-2-2.9l-30.8-13.9c-0.9-0.5-2-0.5-2.9,0.2l-17.6,9.6c-1.1,0.6-1.7,1.7-1.7,3.1
				c0,1.2,0.8,2.3,1.8,2.9l29.7,13.9c0.5,0.3,1.1,0.3,1.5,0.3c0.5,0,0.9-0.2,1.4-0.3l18.7-9.6C438.6,214.8,439.3,213.6,439.2,212.3z
				 M428.5,212.6l-11.2,5.8L395,207.9l10.4-5.7L428.5,212.6z"
            />
          </g>
        </g>
      </g>
      <g id="Laag_4_1_" display="none">
        <g id="Laag_2_1_" display="inline">
          <path
            fill="#222222"
            d="M260.5,136.3l-70.4,34c2.4,1.4,4.9,2.8,7.3,4.3l63-30.3l242.3,121.2l3.2-6.3L260.5,136.3z"
          />
          <polygon
            fill="#222222"
            points="81.4,222.6 0.4,261.6 3.5,267.9 81.4,230.4 		"
          />
          <g>
            <path
              fill="#222222"
              d="M281.9,194.4c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.2l-32.9,15l-74.4-36.1v-33
				c0-1.2-0.6-2.3-1.5-2.9c-0.9-0.6-2.3-0.8-3.4-0.3l-72.2,30.9c-1.2,0.6-2.1,1.8-2.1,3.2v69.3c0,1.4,0.8,2.6,2,3.2L207,295.6
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l63.6-29.7l0.5,21.9l-50.6,24.3
				c-1.7,0.9-2.4,2.9-1.7,4.7c0.9,1.7,2.9,2.4,4.7,1.7l52.6-25.4c1.2-0.6,2-1.8,2-3.2L281.9,194.4z M162.6,142.6v27.7l-51.1,23.9
				c-1.8,0.8-2.6,2.9-1.7,4.7c0.6,1.2,1.8,2,3.2,2c0.5,0,1.1-0.2,1.5-0.3l51.6-24l69.6,33.8L207,223.5c-1.2,0.6-2,1.8-2,3.2v30.6
				L97.4,205.9v-35.2L162.6,142.6z M97.4,235.3v-21.9L205,264.8v22L97.4,235.3z M212,257.2v-28.3l63-28.9l0.5,27.5L212,257.2z"
            />
            <path
              fill="#222222"
              d="M134,208.2l20,10.1c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.1-0.2,1.7-0.3l31.7-15.3c1.2-0.6,2-1.8,2-3.1
				c0-1.4-0.8-2.6-1.8-3.2l-19-10.1c-0.9-0.5-2.1-0.6-3.2-0.2L134,201.8c-1.2,0.6-2,1.8-2,3.2C132,206.4,132.9,207.7,134,208.2z
				 M168.2,193.8l11.3,6l-23.9,11.5l-12.1-6L168.2,193.8z"
            />
          </g>
        </g>
      </g>
    </g>
  ),

  basic: (
    <g>
      <polygon
        fill="#222222"
        points="46.7,239.4 -0.1,261.9 2.8,268.1 46.7,246.9 "
      />
      <g>
        <path
          fill="#222222"
          d="M297.2,188.5c0-1.1-0.6-2.2-1.6-2.8c-1-0.6-2.2-0.7-3.2-0.2l-32.1,14.3c-0.1-0.1-0.3-0.2-0.4-0.3
		l-70.7-34.3v-31.9c0-1.1-0.6-2.2-1.5-2.8c-1-0.6-2.2-0.7-3.2-0.3L57.3,184.8c-1.2,0.5-2.1,1.8-2.1,3.1v66.8c0,1.3,0.7,2.5,1.9,3.1
		l110.3,52.9c0.5,0.2,1,0.3,1.5,0.3c0.6,0,1.3-0.2,1.8-0.5c1-0.6,1.6-1.7,1.6-2.9v-26.4l106.2-48.4c1.7-0.8,2.5-2.8,1.7-4.5
		c-0.8-1.7-2.8-2.5-4.5-1.7l-103.3,47.1v-27.3l118.2-52.6l1,55L185.3,297c-1.7,0.8-2.5,2.8-1.7,4.5c0.8,1.7,2.8,2.5,4.5,1.7
		L296.3,254c1.2-0.6,2-1.8,2-3.1L297.2,188.5z M62,252.5v-21l103.5,49.6v21L62,252.5z M167.6,241.1c-1.2,0.5-2,1.8-2,3.1v29.4
		L62,224.1v-33.9l120.4-51.6v26.6l-104,46.5c-1.7,0.8-2.5,2.8-1.7,4.5c0.6,1.3,1.8,2,3.1,2c0.5,0,0.9-0.1,1.4-0.3l104.5-46.8
		l66.5,32.3L167.6,241.1z"
        />
        <path
          fill="#222222"
          d="M159.2,214.8l-21.6-11.6c-0.9-0.5-2.1-0.5-3-0.1l-37.4,17.3c-1.2,0.5-1.9,1.7-2,3c0,1.3,0.7,2.5,1.9,3.1
		l22.8,11.6c0.5,0.2,1,0.4,1.5,0.4c0.5,0,1-0.1,1.5-0.3l36.2-17.3c1.2-0.6,1.9-1.7,1.9-3C161,216.6,160.3,215.4,159.2,214.8z
		 M121.5,231.3l-15.1-7.6l29.5-13.6l14.2,7.6L121.5,231.3z"
        />
        <path
          fill="#222222"
          d="M184.7,179.1l-37.4,17.3c-1.2,0.5-1.9,1.7-2,3c0,1.3,0.7,2.5,1.9,3.1l22.8,11.6c0.5,0.2,1,0.4,1.5,0.4
		c0.5,0,1-0.1,1.5-0.3l36.2-17.3c1.2-0.6,1.9-1.7,1.9-3c0-1.3-0.7-2.5-1.8-3.1l-21.6-11.6C186.8,178.7,185.7,178.7,184.7,179.1z
		 M200.2,193.6l-28.6,13.7l-15.1-7.6L186,186L200.2,193.6z"
        />
      </g>
      <path
        fill="#222222"
        d="M275.6,130l-67.8,32.6c2.3,1.3,4.7,2.7,7,4.1l60.7-29.2L509,254.2l3-6.1L275.6,130z"
      />
      <g id="Laag_1_2_" display="none">
        <g id="Laag_1_1_" display="inline">
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2l114.5,55
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3L362,195.4c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2l114.5,55
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3L362,195.4c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
        </g>
      </g>
      <g id="Laag_2" display="none">
        <g id="Laag_4_3_" display="inline">
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2l114.5,55
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2s0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3L362,195.4c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
        </g>
      </g>
      <g id="Laag_3" display="none">
        <g id="Laag_3_1_" display="inline">
          <g>
            <path
              fill="#222222"
              d="M271.4,223.7c0-0.3,0-0.6,0-0.9v-46.2c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.6-3.1-0.2l-31.7,14.7
				l-69.5-33.7v-31.1c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.8-3.1-0.3l-67.6,28.9c-1.2,0.5-2,1.7-2,3.1v99.7c0,1.2,0.8,2.4,1.8,2.9
				l106.9,51.3c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.2-0.2,1.7-0.5c0.9-0.6,1.5-1.7,1.5-2.8v-47.6l59.8-27.7v42.4l-47.3,22.8
				c-1.7,0.8-2.3,2.8-1.5,4.4c0.8,1.7,2.8,2.3,4.4,1.5l49.1-23.7c1.2-0.6,1.8-1.7,1.8-3.1L271.4,223.7z M158.9,128.7v25.9
				l-47.6,22.2c-1.7,0.8-2.3,2.8-1.5,4.4c0.6,1.2,1.7,1.8,3.1,1.8c0.5,0,0.9-0.2,1.4-0.3l48.2-22.5l65,31.5l-26.8,12.2
				c-1.2,0.6-2,1.7-2,3.1v28.5L98,187.4v-32.7L158.9,128.7z M198.4,248.9L98,200.9v-6.1l100.4,48V248.9z M153.7,235.4l-11.8,6.3
				l-11.5-5.2l12.4-6.4L153.7,235.4z M98,208.2l23.6,11.3L98,232.1V208.2z M126.6,224.3c0.8-0.3,1.2-0.9,1.5-1.7l8.1,3.8l-14.8,7.5
				c-1.1,0.6-1.8,1.7-1.8,3.1c0,1.2,0.8,2.4,2,2.9l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.1-0.2,1.5-0.5l18.2-9.8l36.7,17.6v27.5
				L102,237.6L126.6,224.3z M98,250.1v-7.2l100.4,48v7.3L98,250.1z M205,248.7v-39.6l31.2-14.2h0.2l28.5-13.2l-0.2,39.5L205,248.7z"
            />
            <path
              fill="#222222"
              d="M132.5,190.8l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3s1.1-0.2,1.5-0.5l29.1-15.5c1.1-0.6,1.8-1.7,1.7-2.9
				c0-1.2-0.8-2.3-1.8-2.9l-18.1-8.7c-0.9-0.5-2-0.5-2.9,0l-30,15.5c-1.1,0.6-1.8,1.7-1.8,3.1C130.6,189.1,131.4,190.2,132.5,190.8z
				 M164,175.9l10.7,5.2l-21.9,11.6l-11.5-5.2L164,175.9z"
            />
          </g>
          <polygon fill="#222222" points="78,223.8 2,260.4 5,266.8 78,231.6 		" />
          <polygon
            fill="#222222"
            points="488.8,248.6 488.8,256.5 509,266.5 512.2,260.2 		"
          />
          <path
            fill="#222222"
            d="M369.9,189.1l-107.9-54l-61.3,29.5c2.9,1.2,5.8,2.4,8.6,3.7l52.6-25.2l99.3,49.6
			C364.1,191.5,367,190.3,369.9,189.1z"
          />
          <g>
            <path
              fill="#222222"
              d="M298.3,298.5c0,1.2,0.8,2.4,1.8,3.1l49.1,23.7c1.7,0.8,3.7,0.2,4.4-1.5s0.2-3.7-1.5-4.4l-47.3-22.8v-42.4
				l59.8,27.7v47.6c0,1.1,0.6,2.1,1.5,2.8c0.5,0.3,1.1,0.5,1.7,0.5c0.5,0,0.9-0.2,1.4-0.3l107-51.5c1.1-0.6,1.8-1.7,1.8-2.9v-99.9
				c0-1.4-0.8-2.4-2-3.1l-67.5-28.8c-1.1-0.5-2.1-0.3-3.1,0.3s-1.5,1.7-1.5,2.8v30.9L334.5,214l-31.7-14.7c-1.1-0.5-2.1-0.5-3.1,0.2
				c-0.9,0.6-1.5,1.7-1.5,2.8v46.2c0,0.3,0,0.6,0,0.9L298.3,298.5z M471.6,180.5v32.9l-100.4,48V233c0-1.2-0.8-2.4-2-3.1l-26.8-12.2
				l65-31.5l48.2,22.5c0.5,0.2,0.9,0.3,1.4,0.3c1.2,0,2.4-0.8,3.1-1.8c0.8-1.7,0-3.7-1.5-4.4l-47.7-22.2v-26L471.6,180.5z
				 M371.3,268.6l100.4-48v6.1l-100.4,48V268.6z M426.8,256.2l12.4,6.4l-11.5,5.2l-11.8-6.3L426.8,256.2z M471.6,257.8L448,245.3
				l23.6-11.3V257.8z M467.8,263.3l-96.5,46.2V282l36.7-17.6l18.2,9.8c0.5,0.3,1.1,0.5,1.5,0.5c0.5,0,0.9-0.2,1.4-0.3l19.1-8.7
				c1.2-0.5,1.8-1.7,2-2.9c0-1.2-0.6-2.4-1.8-3.1l-14.8-7.5l8.1-3.8c0.3,0.6,0.8,1.2,1.5,1.7L467.8,263.3z M371.3,324.2v-7.3
				l100.4-48v7.2L371.3,324.2z M305,246.9l-0.2-39.5l28.5,13.2c0,0,0,0,0.2,0l31.2,14.2v39.8L305,246.9z"
            />
            <path
              fill="#222222"
              d="M439.2,212.3c0-1.2-0.8-2.4-2-2.9l-30.8-13.9c-0.9-0.5-2-0.5-2.9,0.2l-17.6,9.6c-1.1,0.6-1.7,1.7-1.7,3.1
				c0,1.2,0.8,2.3,1.8,2.9l29.7,13.9c0.5,0.3,1.1,0.3,1.5,0.3c0.5,0,0.9-0.2,1.4-0.3l18.7-9.6C438.6,214.8,439.3,213.6,439.2,212.3z
				 M428.5,212.6l-11.2,5.8L395,207.9l10.4-5.7L428.5,212.6z"
            />
          </g>
        </g>
      </g>
    </g>
  ),

  comfort: (
    <g>
      <g id="Laag_1" display="none">
        <g id="Laag_1_1_" display="inline">
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
          <path
            fill="#222222"
            d="M370.8,198.6l-109.7-55.2l-2.3-138l112,52.6V198.6z M267.5,139.5l96.2,47.4V62.4l-97.9-45.9L267.5,139.5z"
          />
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>
          <path
            fill="#222222"
            d="M291.9,341.3c-0.6,0-1.1-0.2-1.7-0.5l-87.5-41.5c-1.7-0.9-2.4-3.1-1.5-4.7c0.9-1.7,3.1-2.4,4.7-1.5
			l86,40.7l66.4-32.6l-75.7-37.8c-1.7-0.9-2.3-3.1-1.4-4.7c0.9-1.7,3.1-2.3,4.7-1.4l81.7,41c1.2,0.6,1.8,1.8,1.8,3.2
			c0,1.4-0.8,2.4-2,3.1l-74,36.4C292.9,341.2,292.3,341.3,291.9,341.3z"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
          <path
            fill="#222222"
            d="M65.4,158.3c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C65.6,191.4,65.6,174.9,65.4,158.3z"
          />
          <path
            fill="#222222"
            d="M197.6,96.5c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C197.6,129.6,197.6,113,197.6,96.5z"
          />
          <path
            fill="#222222"
            d="M180,212.6c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C180.2,245.7,180.2,229.2,180,212.6z"
          />
          <path
            fill="#222222"
            d="M310.4,151c0-33-0.2-65.9-0.2-65.9c0-2-1.5-3.5-3.5-3.5l0,0c-2,0-3.5,1.5-3.5,3.5
			c0.2,50.3,0.3,126.2,0,131.4c-0.2,0.6,0,1.4,0.3,2.1c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-9.2
			c0-3.7,0-8.7,0-15C310.4,183.9,310.4,167.4,310.4,151z"
          />
          <path
            fill="#222222"
            d="M350.6,116.9c0-31.7-0.2-63.5-0.2-63.5c0-1.8-1.5-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.2,48.5,0.3,121.5,0,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,2,3.2,2c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.9-8.7
			c0-3.5,0-8.4,0-14.4C350.8,148.7,350.6,132.8,350.6,116.9z"
          />
          <path
            fill="#222222"
            d="M286.4,84c-0.3-31.7-0.6-63.5-0.6-63.5c0-1.8-1.7-3.4-3.5-3.4l0,0c-2,0-3.5,1.5-3.5,3.4
			c0.6,48.5,1.4,121.5,1.1,126.4c-0.2,0.6,0,1.4,0.3,2c0.6,1.2,1.8,1.8,3.2,1.8c0.3,0,0.5,0,0.8-0.2c2.8-0.6,2.8-1.5,2.8-8.7
			c0-3.5,0-8.4,0-14.4C286.7,115.8,286.5,99.9,286.4,84z"
          />
        </g>
      </g>
      <g id="Laag_2">
        <g id="Laag_4_3_">
          <path
            fill="#222222"
            d="M361.6,185.7L261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6l91.8,45.9
			C355.7,188,358.7,186.9,361.6,185.7z"
          />
          <polygon
            fill="#222222"
            points="488,248.9 488,256.9 503.3,264.5 506.4,258.1 		"
          />
          <polygon
            fill="#222222"
            points="49.5,237.3 0.9,260.7 3.9,267 49.5,245.1 		"
          />
          <g>
            <path
              fill="#222222"
              d="M309.8,184.3c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3L271.4,196c-0.2-0.2-0.3-0.2-0.5-0.3
				L197.5,160v-32.9c0-1.2-0.6-2.3-1.5-2.9s-2.3-0.8-3.4-0.3l-132,56.6c-1.2,0.6-2.1,1.8-2.1,3.2V253c0,1.4,0.8,2.6,2,3.2L175,311.2
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l110.3-50.3c1.8-0.8,2.6-2.9,1.7-4.7
				c-0.8-1.8-2.9-2.6-4.7-1.7l-107.2,49v-28.3l122.7-54.6l1.1,57.1l-110.3,50.2c-1.8,0.8-2.6,2.9-1.7,4.7c0.8,1.8,2.9,2.6,4.7,1.7
				L309,252.3c1.2-0.6,2.1-1.8,2.1-3.2L309.8,184.3z M65.4,250.9v-21.7L173,280.6v21.9L65.4,250.9z M175.1,239
				c-1.2,0.6-2.1,1.8-2.1,3.2v30.6L65.4,221.4v-35.2l125-53.5v27.7l-108,48.3c-1.8,0.8-2.6,2.9-1.8,4.6c0.6,1.4,1.8,2.1,3.2,2.1
				c0.5,0,0.9-0.2,1.4-0.3l108.6-48.7l69.2,33.5L175.1,239z"
            />
            <path
              fill="#222222"
              d="M166.4,211.7l-22.3-11.9c-0.9-0.5-2.1-0.6-3.2-0.2L102,217.5c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2
				l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1C168.2,213.6,167.6,212.3,166.4,211.7z
				 M127.2,228.9l-15.6-8l30.6-14.2l14.7,8L127.2,228.9z"
            />
            <path
              fill="#222222"
              d="M192.9,174.7L154,192.6c-1.2,0.6-2,1.8-2,3.2c0,1.4,0.8,2.6,2,3.2l23.7,11.9c0.5,0.3,1.1,0.3,1.5,0.3
				s1.1-0.2,1.5-0.3l37.5-17.9c1.2-0.6,2-1.8,2-3.1c0-1.4-0.8-2.6-1.8-3.2l-22.3-11.9C195,174.2,194,174.1,192.9,174.7z
				 M208.9,189.7l-29.7,14.2l-15.6-8l30.6-14.2L208.9,189.7z"
            />
          </g>
          <g>
            <path
              fill="#222222"
              d="M443.2,196l12.7,6.1c1.7,0.9,3.8,0.2,4.7-1.5s0.2-3.8-1.5-4.7l-17.7-8.7
				C441.9,190.2,442.6,193.1,443.2,196z"
            />
            <path
              fill="#222222"
              d="M476.4,208.2c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.3l-44.8,20.2l-54.9-26.6l32.9-14.8
				c0.2-2.9,0.8-5.7,1.4-8.3l-43.9,19.9c0,0,0,0-0.2,0c-0.5,0.3-1.1,0.6-1.4,1.2l-0.2,0.2c0,0.2-0.2,0.2-0.2,0.3
				c0,0.2-0.2,0.3-0.2,0.5v0.2c-0.2,0.3-0.2,0.6-0.2,0.9l0,0V252c0,1.4,0.8,2.6,2,3.2l63.2,29.7c0.5,0.3,1.1,0.3,1.5,0.3
				c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-50.2l39.3-17.7l0.8,44.1l-30.4,14.5c-1.7,0.8-2.4,2.9-1.7,4.7
				c0.8,1.7,2.9,2.4,4.7,1.7l32.6-15.5c1.2-0.6,2-1.8,2-3.2L476.4,208.2z M423,276l-56-26.3v-45.6l56,27.2V276z"
            />
            <path
              fill="#222222"
              d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-0.8-2l-0.3,0.2c-2.9-4.3-6-6.4-9.3-6.4c-0.2,0-0.2,0-0.3,0
				c-2.6,0.2-4.9,1.5-6.4,3.5l0,0l-0.3,0.5c-0.5,0.6-0.9,1.4-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4l2.6,1.1
				c0.3,0.2,3.8,1.5,8.6,2.8c-0.3,2.1-0.6,5.8-0.9,9.8v0.9l0.5,0.8c2.3,3.2,5.4,4,8,4c2.4,0,4.3-0.6,4.4-0.8l1.5-0.6v-1.5
				c0-0.3,0.2-6.7,0-10.6l0,0c2.8,0,5.4-0.3,7.8-1.1l2.3-0.8L438.1,191.7z M424,204.5c-1.4,0.2-3.5,0.2-4.9-1.2
				c0.3-3.1,0.6-5.8,0.8-7.6c1.2,0.5,2.9,0.9,4.3,1.2C424,199.2,424,202.4,424,204.5z M422.1,173.8c1.4-0.2,2.9,0.9,4.4,2.9
				c-2.3,0.3-5.2,0.3-7.5-1.1C419.8,174.7,420.8,173.8,422.1,173.8z M417.5,189.5l-1.5-0.6v0.3c-1.8-0.5-3.4-0.9-4.6-1.4
				c1.1-1.8,2.9-4.6,5.2-8.1c4.3,2.4,9.6,2,12.5,1.4c0.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5z"
            />
          </g>

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M176.5,276.1"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M61.6,225.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M194.9,164.5"
          />

          <path
            fill="#222222"
            stroke="#222222"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M306.9,223.4"
          />
        </g>
      </g>
      <g id="Laag_3" display="none">
        <g id="Laag_3_1_" display="inline">
          <g>
            <path
              fill="#222222"
              d="M271.4,223.7c0-0.3,0-0.6,0-0.9v-46.2c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.6-3.1-0.2l-31.7,14.7
				l-69.5-33.7v-31.1c0-1.1-0.6-2.1-1.5-2.8c-0.9-0.6-2.1-0.8-3.1-0.3l-67.6,28.9c-1.2,0.5-2,1.7-2,3.1v99.7c0,1.2,0.8,2.4,1.8,2.9
				l106.9,51.3c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.2-0.2,1.7-0.5c0.9-0.6,1.5-1.7,1.5-2.8v-47.6l59.8-27.7v42.4l-47.3,22.8
				c-1.7,0.8-2.3,2.8-1.5,4.4c0.8,1.7,2.8,2.3,4.4,1.5l49.1-23.7c1.2-0.6,1.8-1.7,1.8-3.1L271.4,223.7z M158.9,128.7v25.9
				l-47.6,22.2c-1.7,0.8-2.3,2.8-1.5,4.4c0.6,1.2,1.7,1.8,3.1,1.8c0.5,0,0.9-0.2,1.4-0.3l48.2-22.5l65,31.5l-26.8,12.2
				c-1.2,0.6-2,1.7-2,3.1v28.5L98,187.4v-32.7L158.9,128.7z M198.4,248.9L98,200.9v-6.1l100.4,48V248.9z M153.7,235.4l-11.8,6.3
				l-11.5-5.2l12.4-6.4L153.7,235.4z M98,208.2l23.6,11.3L98,232.1V208.2z M126.6,224.3c0.8-0.3,1.2-0.9,1.5-1.7l8.1,3.8l-14.8,7.5
				c-1.1,0.6-1.8,1.7-1.8,3.1c0,1.2,0.8,2.4,2,2.9l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.1-0.2,1.5-0.5l18.2-9.8l36.7,17.6v27.5
				L102,237.6L126.6,224.3z M98,250.1v-7.2l100.4,48v7.3L98,250.1z M205,248.7v-39.6l31.2-14.2h0.2l28.5-13.2l-0.2,39.5L205,248.7z"
            />
            <path
              fill="#222222"
              d="M132.5,190.8l19.1,8.7c0.5,0.2,0.9,0.3,1.4,0.3c0.5,0,1.1-0.2,1.5-0.5l29.1-15.5c1.1-0.6,1.8-1.7,1.7-2.9
				c0-1.2-0.8-2.3-1.8-2.9l-18.1-8.7c-0.9-0.5-2-0.5-2.9,0l-30,15.5c-1.1,0.6-1.8,1.7-1.8,3.1C130.6,189.1,131.4,190.2,132.5,190.8z
				 M164,175.9l10.7,5.2l-21.9,11.6l-11.5-5.2L164,175.9z"
            />
          </g>
          <polygon fill="#222222" points="78,223.8 2,260.4 5,266.8 78,231.6 		" />
          <polygon
            fill="#222222"
            points="488.8,248.6 488.8,256.5 509,266.5 512.2,260.2 		"
          />
          <path
            fill="#222222"
            d="M369.9,189.1l-107.9-54l-61.3,29.5c2.9,1.2,5.8,2.4,8.6,3.7l52.6-25.2l99.3,49.6
			C364.1,191.5,367,190.3,369.9,189.1z"
          />
          <g>
            <path
              fill="#222222"
              d="M298.3,298.5c0,1.2,0.8,2.4,1.8,3.1l49.1,23.7c1.7,0.8,3.7,0.2,4.4-1.5s0.2-3.7-1.5-4.4l-47.3-22.8v-42.4
				l59.8,27.7v47.6c0,1.1,0.6,2.1,1.5,2.8c0.5,0.3,1.1,0.5,1.7,0.5c0.5,0,0.9-0.2,1.4-0.3L476.2,281c1.1-0.6,1.8-1.7,1.8-2.9v-99.9
				c0-1.4-0.8-2.4-2-3.1l-67.5-28.8c-1.1-0.5-2.1-0.3-3.1,0.3s-1.5,1.7-1.5,2.8v30.9L334.5,214l-31.7-14.7c-1.1-0.5-2.1-0.5-3.1,0.2
				c-0.9,0.6-1.5,1.7-1.5,2.8v46.2c0,0.3,0,0.6,0,0.9L298.3,298.5z M471.6,180.5v32.9l-100.4,48V233c0-1.2-0.8-2.4-2-3.1l-26.8-12.2
				l65-31.5l48.2,22.5c0.5,0.2,0.9,0.3,1.4,0.3c1.2,0,2.4-0.8,3.1-1.8c0.8-1.7,0-3.7-1.5-4.4l-47.7-22.2v-26L471.6,180.5z
				 M371.3,268.6l100.4-48v6.1l-100.4,48V268.6z M426.8,256.2l12.4,6.4l-11.5,5.2l-11.8-6.3L426.8,256.2z M471.6,257.8l-23.6-12.5
				l23.6-11.3V257.8z M467.8,263.3l-96.5,46.2v-27.5l36.7-17.6l18.2,9.8c0.5,0.3,1.1,0.5,1.5,0.5c0.5,0,0.9-0.2,1.4-0.3l19.1-8.7
				c1.2-0.5,1.8-1.7,2-2.9c0-1.2-0.6-2.4-1.8-3.1l-14.8-7.5l8.1-3.8c0.3,0.6,0.8,1.2,1.5,1.7L467.8,263.3z M371.3,324.2v-7.3
				l100.4-48v7.2L371.3,324.2z M305,246.9l-0.2-39.5l28.5,13.2c0,0,0,0,0.2,0l31.2,14.2v39.8L305,246.9z"
            />
            <path
              fill="#222222"
              d="M439.2,212.3c0-1.2-0.8-2.4-2-2.9l-30.8-13.9c-0.9-0.5-2-0.5-2.9,0.2l-17.6,9.6c-1.1,0.6-1.7,1.7-1.7,3.1
				c0,1.2,0.8,2.3,1.8,2.9l29.7,13.9c0.5,0.3,1.1,0.3,1.5,0.3c0.5,0,0.9-0.2,1.4-0.3l18.7-9.6C438.6,214.8,439.3,213.6,439.2,212.3z
				 M428.5,212.6l-11.2,5.8L395,207.9l10.4-5.7L428.5,212.6z"
            />
          </g>
        </g>
      </g>
      <g id="Laag_4_1_" display="none">
        <g id="Laag_2_1_" display="inline">
          <path
            fill="#222222"
            d="M260.5,136.3l-70.4,34c2.4,1.4,4.9,2.8,7.3,4.3l63-30.3l242.3,121.2l3.2-6.3L260.5,136.3z"
          />
          <polygon
            fill="#222222"
            points="81.4,222.6 0.4,261.6 3.5,267.9 81.4,230.4 		"
          />
          <g>
            <path
              fill="#222222"
              d="M281.9,194.4c0-1.2-0.6-2.3-1.7-2.9c-1.1-0.6-2.3-0.8-3.4-0.2l-32.9,15l-74.4-36.1v-33
				c0-1.2-0.6-2.3-1.5-2.9c-0.9-0.6-2.3-0.8-3.4-0.3l-72.2,30.9c-1.2,0.6-2.1,1.8-2.1,3.2v69.3c0,1.4,0.8,2.6,2,3.2L207,295.6
				c0.5,0.3,1.1,0.3,1.5,0.3c0.6,0,1.4-0.2,1.8-0.6c1.1-0.6,1.7-1.8,1.7-3.1v-27.4l63.6-29.7l0.5,21.9l-50.6,24.3
				c-1.7,0.9-2.4,2.9-1.7,4.7c0.9,1.7,2.9,2.4,4.7,1.7l52.6-25.4c1.2-0.6,2-1.8,2-3.2L281.9,194.4z M162.6,142.6v27.7l-51.1,23.9
				c-1.8,0.8-2.6,2.9-1.7,4.7c0.6,1.2,1.8,2,3.2,2c0.5,0,1.1-0.2,1.5-0.3l51.6-24l69.6,33.8L207,223.5c-1.2,0.6-2,1.8-2,3.2v30.6
				L97.4,205.9v-35.2L162.6,142.6z M97.4,235.3v-21.9L205,264.8v22L97.4,235.3z M212,257.2v-28.3l63-28.9l0.5,27.5L212,257.2z"
            />
            <path
              fill="#222222"
              d="M134,208.2l20,10.1c0.5,0.2,0.9,0.3,1.4,0.3c0.6,0,1.1-0.2,1.7-0.3l31.7-15.3c1.2-0.6,2-1.8,2-3.1
				c0-1.4-0.8-2.6-1.8-3.2l-19-10.1c-0.9-0.5-2.1-0.6-3.2-0.2L134,201.8c-1.2,0.6-2,1.8-2,3.2C132,206.4,132.9,207.7,134,208.2z
				 M168.2,193.8l11.3,6l-23.9,11.5l-12.1-6L168.2,193.8z"
            />
          </g>
        </g>
      </g>
    </g>
  ),

  premium: (
    <g>
      <g>
        <path
          d="M370.8,198.6,261.1,143.4l-2.3-138L370.8,58ZM267.5,139.5l96.2,47.4V62.4L265.8,16.5Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M361.6,185.7,261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6L352.7,189C355.7,188,358.7,186.9,361.6,185.7Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <polygon
          points="487.1 243.5 487.1 251.5 502.4 259.1 505.5 252.7 487.1 243.5"
          fill="#222"
        />
        <polygon
          points="48.6 231.9 0 255.3 3 261.6 48.6 239.7 48.6 231.9"
          fill="#222"
        />
        <g>
          <path
            d="M309.8,184.3a3.24,3.24,0,0,0-1.7-2.9,3.75,3.75,0,0,0-3.4-.3L271.4,196a1.33,1.33,0,0,0-.5-.3L197.5,160V127.1a3.5,3.5,0,0,0-1.5-2.9,3.7,3.7,0,0,0-3.4-.3l-132,56.6a3.66,3.66,0,0,0-2.1,3.2V253a3.56,3.56,0,0,0,2,3.2l114.5,55a2.88,2.88,0,0,0,1.5.3,2.79,2.79,0,0,0,1.8-.6,3.45,3.45,0,0,0,1.7-3.1V280.4l110.3-50.3a3.53,3.53,0,1,0-3-6.4l-107.2,49V244.4l122.7-54.6,1.1,57.1L193.6,297.1a3.53,3.53,0,0,0,3,6.4L309,252.3a3.66,3.66,0,0,0,2.1-3.2ZM65.4,250.9V229.2L173,280.6v21.9ZM175.1,239a3.66,3.66,0,0,0-2.1,3.2v30.6L65.4,221.4V186.2l125-53.5v27.7l-108,48.3a3.47,3.47,0,0,0-1.8,4.6,3.34,3.34,0,0,0,3.2,2.1,7,7,0,0,0,1.4-.3l108.6-48.7L263,199.9Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M166.4,211.7l-22.3-11.9a3.93,3.93,0,0,0-3.2-.2L102,217.5a3.56,3.56,0,0,0,0,6.4l23.7,11.9a2.88,2.88,0,0,0,1.5.3,8,8,0,0,0,1.5-.3l37.5-17.9a3.53,3.53,0,0,0,2-3.1A3.45,3.45,0,0,0,166.4,211.7Zm-39.2,17.2-15.6-8,30.6-14.2,14.7,8Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M192.9,174.7,154,192.6a3.56,3.56,0,0,0,0,6.4l23.7,11.9a2.88,2.88,0,0,0,1.5.3,8,8,0,0,0,1.5-.3L218.2,193a3.53,3.53,0,0,0,2-3.1,3.79,3.79,0,0,0-1.8-3.2l-22.3-11.9A3.07,3.07,0,0,0,192.9,174.7Zm16,15-29.7,14.2-15.6-8,30.6-14.2Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
        </g>
        <g>
          <path
            d="M443.2,196l12.7,6.1a3.49,3.49,0,1,0,3.2-6.2l-17.7-8.7C441.9,190.2,442.6,193.1,443.2,196Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M476.4,208.2a3.24,3.24,0,0,0-1.7-2.9,3.75,3.75,0,0,0-3.4-.3l-44.8,20.2-54.9-26.6,32.9-14.8a53.21,53.21,0,0,1,1.4-8.3L362,195.4h-.2a3.23,3.23,0,0,0-1.4,1.2l-.2.2c0,.2-.2.2-.2.3s-.2.3-.2.5v.2a1.49,1.49,0,0,0-.2.9h0V252a3.56,3.56,0,0,0,2,3.2l63.2,29.7a2.88,2.88,0,0,0,1.5.3,2.79,2.79,0,0,0,1.8-.6,3.45,3.45,0,0,0,1.7-3.1V231.3l39.3-17.7.8,44.1-30.4,14.5a3.53,3.53,0,0,0,3,6.4l32.6-15.5a3.56,3.56,0,0,0,2-3.2ZM423,276l-56-26.3V204.1l56,27.2Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-.8-2-.3.2c-2.9-4.3-6-6.4-9.3-6.4h-.3a8.81,8.81,0,0,0-6.4,3.5h0l-.3.5a10.6,10.6,0,0,0-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4,2.6,1.1a67.1,67.1,0,0,0,8.6,2.8c-.3,2.1-.6,5.8-.9,9.8v.9l.5.8a9.39,9.39,0,0,0,8,4,9.58,9.58,0,0,0,4.4-.8l1.5-.6v-1.5c0-.3.2-6.7,0-10.6h0a24.53,24.53,0,0,0,7.8-1.1l2.3-.8ZM424,204.5c-1.4.2-3.5.2-4.9-1.2.3-3.1.6-5.8.8-7.6a27,27,0,0,0,4.3,1.2C424,199.2,424,202.4,424,204.5Zm-1.9-30.7c1.4-.2,2.9.9,4.4,2.9-2.3.3-5.2.3-7.5-1.1A4.35,4.35,0,0,1,422.1,173.8Zm-4.6,15.7-1.5-.6v.3a43.8,43.8,0,0,1-4.6-1.4c1.1-1.8,2.9-4.6,5.2-8.1,4.3,2.4,9.6,2,12.5,1.4.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
        </g>
        <path
          d="M291.9,341.3a3.69,3.69,0,0,1-1.7-.5l-87.5-41.5a3.49,3.49,0,0,1,3.2-6.2l86,40.7,66.4-32.6-75.7-37.8a3.47,3.47,0,1,1,3.3-6.1l81.7,41a3.39,3.39,0,0,1,1.8,3.2,3.53,3.53,0,0,1-2,3.1l-74,36.4A4.43,4.43,0,0,1,291.9,341.3Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M176.5,276.1"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M61.6,225.5"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M194.9,164.5"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M306.9,223.4"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M65.4,158.3c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C65.6,191.4,65.6,174.9,65.4,158.3Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M197.6,96.5c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2V96.5Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M180,212.6c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C180.2,245.7,180.2,229.2,180,212.6Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M310.4,151c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C310.4,183.9,310.4,167.4,310.4,151Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M350.6,116.9c0-31.7-.2-63.5-.2-63.5a3.46,3.46,0,0,0-3.5-3.4h0a3.4,3.4,0,0,0-3.5,3.4c.2,48.5.3,121.5,0,126.4a2.85,2.85,0,0,0,.3,2,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-8.7V160.5C350.8,148.7,350.6,132.8,350.6,116.9Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M286.4,84c-.3-31.7-.6-63.5-.6-63.5a3.6,3.6,0,0,0-3.5-3.4h0a3.4,3.4,0,0,0-3.5,3.4c.6,48.5,1.4,121.5,1.1,126.4a2.85,2.85,0,0,0,.3,2,3.39,3.39,0,0,0,3.2,1.8,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.8-8.7V127.4C286.7,115.8,286.5,99.9,286.4,84Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M370.8,198.6,261.1,143.4l-2.3-138L370.8,58ZM267.5,139.5l96.2,47.4V62.4L265.8,16.5Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M361.6,185.7,261,135.4l-47.7,22.9c2.3,1.5,4.6,3.1,6.9,4.4l40.7-19.6L352.7,189C355.7,188,358.7,186.9,361.6,185.7Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <polygon
          points="487.1 243.5 487.1 251.5 502.4 259.1 505.5 252.7 487.1 243.5"
          fill="#222"
        />
        <polygon
          points="48.6 231.9 0 255.3 3 261.6 48.6 239.7 48.6 231.9"
          fill="#222"
        />
        <g>
          <path
            d="M309.8,184.3a3.24,3.24,0,0,0-1.7-2.9,3.75,3.75,0,0,0-3.4-.3L271.4,196a1.33,1.33,0,0,0-.5-.3L197.5,160V127.1a3.5,3.5,0,0,0-1.5-2.9,3.7,3.7,0,0,0-3.4-.3l-132,56.6a3.66,3.66,0,0,0-2.1,3.2V253a3.56,3.56,0,0,0,2,3.2l114.5,55a2.88,2.88,0,0,0,1.5.3,2.79,2.79,0,0,0,1.8-.6,3.45,3.45,0,0,0,1.7-3.1V280.4l110.3-50.3a3.53,3.53,0,1,0-3-6.4l-107.2,49V244.4l122.7-54.6,1.1,57.1L193.6,297.1a3.53,3.53,0,0,0,3,6.4L309,252.3a3.66,3.66,0,0,0,2.1-3.2ZM65.4,250.9V229.2L173,280.6v21.9ZM175.1,239a3.66,3.66,0,0,0-2.1,3.2v30.6L65.4,221.4V186.2l125-53.5v27.7l-108,48.3a3.47,3.47,0,0,0-1.8,4.6,3.34,3.34,0,0,0,3.2,2.1,7,7,0,0,0,1.4-.3l108.6-48.7L263,199.9Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M166.4,211.7l-22.3-11.9a3.93,3.93,0,0,0-3.2-.2L102,217.5a3.56,3.56,0,0,0,0,6.4l23.7,11.9a2.88,2.88,0,0,0,1.5.3,8,8,0,0,0,1.5-.3l37.5-17.9a3.53,3.53,0,0,0,2-3.1A3.45,3.45,0,0,0,166.4,211.7Zm-39.2,17.2-15.6-8,30.6-14.2,14.7,8Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M192.9,174.7,154,192.6a3.56,3.56,0,0,0,0,6.4l23.7,11.9a2.88,2.88,0,0,0,1.5.3,8,8,0,0,0,1.5-.3L218.2,193a3.53,3.53,0,0,0,2-3.1,3.79,3.79,0,0,0-1.8-3.2l-22.3-11.9A3.07,3.07,0,0,0,192.9,174.7Zm16,15-29.7,14.2-15.6-8,30.6-14.2Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
        </g>
        <g>
          <path
            d="M443.2,196l12.7,6.1a3.49,3.49,0,1,0,3.2-6.2l-17.7-8.7C441.9,190.2,442.6,193.1,443.2,196Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M476.4,208.2a3.24,3.24,0,0,0-1.7-2.9,3.75,3.75,0,0,0-3.4-.3l-44.8,20.2-54.9-26.6,32.9-14.8a53.21,53.21,0,0,1,1.4-8.3L362,195.4h-.2a3.23,3.23,0,0,0-1.4,1.2l-.2.2c0,.2-.2.2-.2.3s-.2.3-.2.5v.2a1.49,1.49,0,0,0-.2.9h0V252a3.56,3.56,0,0,0,2,3.2l63.2,29.7a2.88,2.88,0,0,0,1.5.3,2.79,2.79,0,0,0,1.8-.6,3.45,3.45,0,0,0,1.7-3.1V231.3l39.3-17.7.8,44.1-30.4,14.5a3.53,3.53,0,0,0,3,6.4l32.6-15.5a3.56,3.56,0,0,0,2-3.2ZM423,276l-56-26.3V204.1l56,27.2Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
          <path
            d="M438.1,191.7c-1.4-3.5-5.5-14.2-5.5-14.2l-.8-2-.3.2c-2.9-4.3-6-6.4-9.3-6.4h-.3a8.81,8.81,0,0,0-6.4,3.5h0l-.3.5a10.6,10.6,0,0,0-1.2,2c-5.4,8.3-8.1,12.7-8.1,12.9l-1.5,2.4,2.6,1.1a67.1,67.1,0,0,0,8.6,2.8c-.3,2.1-.6,5.8-.9,9.8v.9l.5.8a9.39,9.39,0,0,0,8,4,9.58,9.58,0,0,0,4.4-.8l1.5-.6v-1.5c0-.3.2-6.7,0-10.6h0a24.53,24.53,0,0,0,7.8-1.1l2.3-.8ZM424,204.5c-1.4.2-3.5.2-4.9-1.2.3-3.1.6-5.8.8-7.6a27,27,0,0,0,4.3,1.2C424,199.2,424,202.4,424,204.5Zm-1.9-30.7c1.4-.2,2.9.9,4.4,2.9-2.3.3-5.2.3-7.5-1.1A4.35,4.35,0,0,1,422.1,173.8Zm-4.6,15.7-1.5-.6v.3a43.8,43.8,0,0,1-4.6-1.4c1.1-1.8,2.9-4.6,5.2-8.1,4.3,2.4,9.6,2,12.5,1.4.9,2.4,2.6,6.7,3.8,9.8C427.9,191.7,422.2,190.8,417.5,189.5Z"
            transform="translate(-0.9 -5.4)"
            fill="#222"
          />
        </g>
        <path
          d="M291.9,341.3a3.69,3.69,0,0,1-1.7-.5l-87.5-41.5a3.49,3.49,0,0,1,3.2-6.2l86,40.7,66.4-32.6-75.7-37.8a3.47,3.47,0,1,1,3.3-6.1l81.7,41a3.39,3.39,0,0,1,1.8,3.2,3.53,3.53,0,0,1-2,3.1l-74,36.4A4.43,4.43,0,0,1,291.9,341.3Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M176.5,276.1"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M61.6,225.5"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M194.9,164.5"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M306.9,223.4"
          transform="translate(-0.9 -5.4)"
          fill="#222"
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M65.4,158.3c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C65.6,191.4,65.6,174.9,65.4,158.3Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M197.6,96.5c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2V96.5Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M180,212.6c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C180.2,245.7,180.2,229.2,180,212.6Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M310.4,151c0-33-.2-65.9-.2-65.9a3.42,3.42,0,0,0-3.5-3.5h0a3.42,3.42,0,0,0-3.5,3.5c.2,50.3.3,126.2,0,131.4a3.2,3.2,0,0,0,.3,2.1,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-9.2v-15C310.4,183.9,310.4,167.4,310.4,151Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M350.6,116.9c0-31.7-.2-63.5-.2-63.5a3.46,3.46,0,0,0-3.5-3.4h0a3.4,3.4,0,0,0-3.5,3.4c.2,48.5.3,121.5,0,126.4a2.85,2.85,0,0,0,.3,2,3.56,3.56,0,0,0,3.2,2,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.9-8.7V160.5C350.8,148.7,350.6,132.8,350.6,116.9Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
        <path
          d="M286.4,84c-.3-31.7-.6-63.5-.6-63.5a3.6,3.6,0,0,0-3.5-3.4h0a3.4,3.4,0,0,0-3.5,3.4c.6,48.5,1.4,121.5,1.1,126.4a2.85,2.85,0,0,0,.3,2,3.39,3.39,0,0,0,3.2,1.8,1.2,1.2,0,0,0,.8-.2c2.8-.6,2.8-1.5,2.8-8.7V127.4C286.7,115.8,286.5,99.9,286.4,84Z"
          transform="translate(-0.9 -5.4)"
          fill="#222"
        />
      </g>
    </g>
  ),
}
